import { NavLink } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';
import useMenuItems from '@/lib/hooks/useMenuItems';
import { cn } from '@/lib/utils/cn';
import { useSettingsStore } from '@/store';

export const DesktopMenu = () => {
  const { settings } = useSettingsStore();
  const { desktopMenuItems, isLoading } = useMenuItems();
  const themedUi = settings?.ui?.theming?.themedUi;

  return (
    <ul className="hidden lg:flex items-center gap-6 h-full">
      {isLoading ? (
        <div className="flex items-center gap-6 h-full">
          <Skeleton
            className="h-6 w-48"
            data-testid="desktop-menu-left-nav-links-skeleton"
          />
          <Skeleton
            className="h-6 w-48"
            data-testid="desktop-menu-left-nav-links-skeleton"
          />
        </div>
      ) : (
        desktopMenuItems.map((item, i) => (
          <li key={i} className="h-full">
            <NavLink
              to={item.path}
              data-testid="desktop-menu-left-nav-links"
              className={({ isActive }) =>
                cn(
                  'border-b-2 transition-all text-sm h-full flex items-center',
                  isActive
                    ? themedUi
                      ? 'border-primary-foreground'
                      : 'border-primary'
                    : 'border-transparent'
                )
              }
            >
              {item.title}
            </NavLink>
          </li>
        ))
      )}
    </ul>
  );
};
